<template>
    <div class="tc-context-helper">
        <SVGMagicApply/>
        <div class="tc-context-helper-text">
            Выберите подходящую Вам конфигурацию
        </div>
    </div>
</template>

<script>
import SVGMagicApply from '@/UI/SVG/SVGMagicApply.vue';

export default {
    name: 'ContextHelperSelect',
    components: { SVGMagicApply },
};
</script>

<style scoped lang="scss">
@import "CSS/lowerHelpers";;
</style>
